// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"11d1e292","726":"2bffa4cc"}[chunkId] + ".chunk.js";
};